module.exports = __webpack_public_path__ + "static/media/zenodo-switch.1453a99e.png";